import { type Node, type Edge } from '@xyflow/react';

export interface ProcessorResult {
  nodes: Node[];
  edges: Edge[];
  processedLogs: unknown[];
}

export abstract class BaseLogProcessor<TInput, TProcessedLog> {
  public abstract processLogs(logData: TInput): TProcessedLog[];

  public abstract convertToFlowData(processedLogs: TProcessedLog[]): ProcessorResult;

  public processAndConvert(logData: TInput): ProcessorResult {
    const processedLogs = this.processLogs(logData);
    return this.convertToFlowData(processedLogs);
  }

  public clear(): void {
    // Override in subclasses if needed
  }

  protected parseTimestamp(timestamp: string): number {
    return new Date(timestamp).getTime();
  }

  protected calculateDuration(startTime: number, endTime: number): number {
    const duration = (endTime - startTime) / 1000;
    return parseFloat((duration === 0 ? 0.0 : duration).toFixed(3));
  }

  protected generateFlowId(flowName: string): string {
    return (
      flowName
        .replace(/\s+/g, '')
        .replace(/[^a-zA-Z0-9]/g, '')
        .substring(0, 20) + Math.random().toString(36).substring(2, 6)
    );
  }
}
